<template>
  <div class="file-item">
    <span class="file-item__text">{{ file.name }} - {{ fileSize }} ({{ file.percent }}%)</span>
    <span class="file-item__progress" :class="!$store.state.isHkom ? 'border-bottom-primary' : 'border-bottom-primary--green'" :style="{ width: file.percent + '%' }"></span>
    <a v-if="file.percent > 0 && file.percent < 100 && !isPaused" href="#" class="pull-right file-item__control" @click.prevent="pauseUploading"><span class="glyphicon glyphicon-pause" aria-hidden="true"></span></a>
    <a v-if="isPaused" href="#" class="pull-right file-item__control" @click.prevent="resumeUploading()"><span class="glyphicon glyphicon-play" aria-hidden="true"></span></a>
    <a href="#" class="pull-right file-item__close" @click.prevent="removeFile"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a>
  </div>
</template>

<script>
import { prettifySize } from '@/utils'

export default {
  name: "FileItem",
  props: {
    index: {
      type: Number,
      required: true,
    },
    file: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isPaused: false
    }
  },
  computed: {
    fileSize() {
      return prettifySize(this.file.size)
    }
  },
  methods: {
    pauseUploading() {
      window.uploader.stop()
      this.isPaused = true
    },
    resumeUploading() {
      // Set file status to QUEUED (1) if not already (maybe it's failed (4)), so it will be picked up by uploader
      window.uploader.getFile(this.file.id).status = 1;
      window.uploader.start()
      this.isPaused = false
    },
    removeFile() {
      window.uploader.stop()
      window.uploader.removeFile(this.file);
      this.$store.removeFile(this.file.id)
      // Start for any unfinished files
      window.uploader.start()
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/sass/abstracts/variables_shared.scss";

.file-item {
  &__text {
    font-size: 13px;
    line-height: 1.45;
    color: $color-grey-darker;
    display: inline-block;
    width: 95%;
  }

  &__progress {
    width: 0%;
    display: inline-block;
    padding: 0;
    margin: 0;
  }

  &__control {
    color: $color-grey-darker;
    position: absolute;
    right: 20px;
    top: 10px;
  }

  &__close {
    color: $color-grey-darker;
    position: absolute;
    right: 0;
    top: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/files/FilesCardItem.vue